/**
 * MUI theme built from the ambient CSS-variable palette so legacy MUI
 * surfaces (settings inputs, dialogs) track the time-of-day palette.
 */

import { createTheme } from '@mui/material/styles';

const commonTypography = {
  fontSize: 14,
  fontFamily: '"Nunito", "Roboto", "Helvetica", "Arial", sans-serif',
  h1: { fontSize: '2.125rem', fontWeight: 600 },
  h2: { fontSize: '1.75rem', fontWeight: 600 },
  h3: { fontSize: '1.5rem', fontWeight: 600 },
  h4: { fontSize: '1.25rem', fontWeight: 600 },
  h5: { fontSize: '1rem', fontWeight: 600 },
  h6: { fontSize: '0.875rem', fontWeight: 600 },
};

export function buildAmbientMuiTheme(vars, mode = 'dark') {
  const dark = mode === 'dark';
  const accent = vars['--ada-accent'];
  const accent2 = vars['--ada-accent-2'];
  const bg = vars['--ada-bg'];
  const soft = dark ? vars['--ada-bg-soft'] : '#ffffff';
  const text = vars['--ada-text'];
  const muted = vars['--ada-muted'];

  return createTheme({
    palette: {
      mode: dark ? 'dark' : 'light',
      primary: { main: accent, contrastText: dark ? '#0a0f1c' : '#ffffff' },
      secondary: { main: accent2 },
      background: { default: bg, paper: soft },
      text: { primary: text, secondary: muted },
    },
    typography: { ...commonTypography },
    spacing: 8,
    shape: { borderRadius: 12 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.875rem',
            padding: '6px 16px',
          },
          sizeSmall: { fontSize: '0.8125rem', padding: '4px 10px' },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            '& fieldset': { borderColor: vars['--ada-border'] },
            '&:hover fieldset': { borderColor: accent },
            '&.Mui-focused fieldset': { borderColor: vars['--ada-focus'] || accent },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: '16px',
            borderBottom: `1px solid ${vars['--ada-border']}`,
          },
          head: { fontWeight: 500, color: text },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
            border: `1px solid ${vars['--ada-border']}`,
          },
        },
      },
    },
  });
}
